import React from 'react';
import { Box, BoxProps, Divider, Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { Loader } from '../Loader';

interface IProps extends BoxProps {
    className?: string;
    description?: React.ReactNode;
    error?: boolean;
    id?: string;
    loading?: boolean;
    title?: string;
    showTitleDivider?: boolean;
    upperRightContent?: React.ReactNode;
}

const BaseDetailBox: React.FC<IProps> = ({
    children,
    className,
    description,
    error,
    id,
    loading,
    title,
    showTitleDivider = true,
    upperRightContent,
    ...props
}) => {
    const { t } = useTranslation();

    let content = loading ? (
        <Box display="flex" justifyContent="center" {...props}>
            <Loader />
        </Box>
    ) : (
        children
    );

    if (error) {
        content = (
            <Box textAlign="center" {...props}>
                <Typography color="error">
                    {t('common.errorFetching')}
                </Typography>
            </Box>
        );
    }

    return (
        <Box className={className} id={id} {...props}>
            <Grid container alignItems="center">
                <Grid item lg={upperRightContent ? 6 : 12} xs={12}>
                    <Typography color="primary" variant="h3">
                        {title}
                    </Typography>
                </Grid>
                {upperRightContent && (
                    <Grid item md={6}>
                        {upperRightContent}
                    </Grid>
                )}
            </Grid>
            {description && (
                <Box mb={2} mt={8}>
                    <Typography color="textSecondary">{description}</Typography>
                </Box>
            )}
            {showTitleDivider && <Divider className="divider" />}
            {content}
        </Box>
    );
};

export const DetailBox = styled(BaseDetailBox)`
    background-color: ${({ theme }) => theme.palette.background.paper};
    padding: ${({ theme }) => `${theme.spacing(6)}px ${theme.spacing(8)}px`};
    margin: ${({ theme }) => `${theme.spacing(6)}px 0`};

    .divider {
        margin: ${({ theme }) =>
            `${theme.spacing(6)}px 0 ${theme.spacing(8)}px 0`};
    }

    span {
        font-weight: 400;
    }
`;
